<template>
<div>
    <v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="Career Map"
            :length="0"
            btn_txt=""
            btn_to="" />

        <div class="display-1 text-center primary--text font-weight-medium mt-8">TOP UNIVERSITIES</div>

        <div class="text-center">
            <v-btn text class="accent--text" @click="$router.push('/map-of-careers')">
                <v-icon small color="accent" left>fa-angle-left</v-icon>
                Back to menu
            </v-btn>
        </div> 

        <v-divider class="mt-3 mb-6"></v-divider>

        <!-- SHOWING COMBO -->
        <div class="d-flex justify-center mt-1">
            <div style="max-width:320px">
                <v-select
                    v-model="showingCombo"
                    :items="categories"
                    item-text="text"
                    item-value="id"
                    outlined dense
                    append-icon="fa-angle-down accent--text"
                    label="Selecciona">
                </v-select>
            </div>
        </div>

        <div v-if="showingCombo=='us' || showingCombo.id=='us'">
            <!-- SEARCH -->
            <div class="d-flex justify-center">
                <div style="width:290px">
                    <v-text-field
                        v-model="search"
                        label="Search"
                        maxlength="100"
                        clearable
                        outlined dense>
                        <template v-slot:append>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-search fa-fw</v-icon>
                        </template>
                    </v-text-field>
                </div>
            </div>

            <!-- INFO -->
            <v-card outlined v-if="loaded">
                <div class="d-flex justify-space-between body-2 font-weight-medium white--text primary pa-6">
                    University
                </div>

                <div class="pt-3">
                    <div :class="{'grey lighten-4': index % 2==1}" v-for="(item, index) in filtered" :key="item.id">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div class="body-2 pl-sm-4 text-center text-sm-left mt-2 mt-sm-0">
                                    {{index+1}}. {{item.name}} 
                                    <!-- <v-avatar color="red" size="22" class="ml-2" v-if="item.hearted">
                                        <span class="body-2 white--text font-weight-medium">1</span>
                                    </v-avatar>    -->
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="d-flex align-center justify-center justify-sm-end pr-sm-4" :class="{'flex-column':$vuetify.breakpoint.xsOnly}">
                                    <div class="body-2 black--text pr-sm-4 mt-n4 mt-sm-0">{{item.location}}</div>
                                    <div class="mt-3 mt-sm-0">
                                        <v-btn small depressed class="bMapCareer white--text" @click="$router.push('/map-of-careers/best-universities/'+item.id)">
                                            more
                                        </v-btn>
                                        <v-btn small fab text class="ml-2" @click="setActual(item)">
                                            <v-icon small color="red" v-if="item.hearted">fa-heart</v-icon>
                                            <v-icon small color="grey" v-else>far fa-heart</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider v-if="index<filtered.length-1"></v-divider>
                    </div>

                    <div class="pt-6 pb-8 caption font-weight-medium info--text d-flex align-center justify-center" v-if="filtered.length==0">
                        <v-icon small class="mr-2" color="info">fa-circle-notch</v-icon>
                        <div>NO RESULTS</div>
                    </div>
                </div>
            </v-card>
        </div>

        <div class="text-center mt-4" v-else>
            Soon you will find it here! <v-icon class="ml-2" color="light-blue">fa-smile-wink</v-icon>
        </div>

        <SendingLoader v-if="!loaded" />
    </v-card>

    <DiagTopUniv 
        v-if="actual!=null"
        :model="showDiagTop" 
        :item="actual"
        @cancel="closeDiag"
        @changed="setHeart" />
</div>
</template>

<script>
import _ from 'lodash'
import Sign from '@/firebase/sign'
import Helpers from '@/services/helpers'
import Careers from '@/firebase/careers'
import DiagTopUniv from '@/components/core/dialogs/DiagTopUniv'

export default {
    data: () => ({
        loaded: false,
        items: [],
        search: null,
        showDiagTop: false,
        actual: null,
        showingCombo: 'us',
        categories: [{id:'us', text:'United States'}, {id:'asia', text:'Asia'}, {id:'europe', text:'Europe'}, {id:'rest', text:'Rest of America'}]
    }),
    components: {
        DiagTopUniv
    },
    mounted() {
        this.init();
    },
    computed: {
        filtered() {
            if (this.search == null) {
                this.search = '';
            }

            return this.items.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase());
                });
        }
    },
    methods: {
        init() {
            Careers.getBestUniversities()
                    .then(response => {
                        if (response.status == true) {
                            this.items = Helpers.formatItems(response.query);
                            this.items = _.sortBy(this.items, 'position');
    
                            if (this.user.mytop && this.user.mytop.universities) {
                                this.setAllHearted(this.user.mytop);
                            }
                            
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        setActual(item) {
            this.actual = item;
            this.showDiagTop = true;
        },
        closeDiag() {
            this.showDiagTop = false;
            this.actual = null;
        },
        setHeart(e) {
            this.setAllHearted(e);
            this.closeDiag();
            Sign.reInitUser(this.user.uid);
        },
        setAllHearted(owner) {
            this.items.forEach(dt => {
                if (dt.hearted) {
                    delete dt.hearted;
                }
            });

            if (owner.universities.p1) {
                let tempo = this.items.find(item => {return item.id == owner.universities.p1.id});
                if (tempo != undefined) {
                    tempo.hearted = true;
                }
            }

            if (owner.universities.p2) {
                let tempo = this.items.find(item => {return item.id == owner.universities.p2.id});
                if (tempo != undefined) {
                    tempo.hearted = true;
                }
            }

            if (owner.universities.p3) {
                let tempo = this.items.find(item => {return item.id == owner.universities.p3.id});
                if (tempo != undefined) {
                    tempo.hearted = true;
                }
            }
        }
    }
}
</script>